import { styled } from '@material-ui/core';

export const TitlesWrapper = styled('div')(({ theme }) => ({
  textAlign: 'center',
  paddingTop: theme.spacing(4),
}));

export const Img = styled('img')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 auto',
  paddingTop: theme.spacing(4),
}));
